export default __webpack_public_path__ + "static/media/icon-hourglass.8049d457.svg";